import React, { useContext } from 'react';
import { Box, CardContent } from '@mui/material';
import LegalProvisionContext from '@raas/shared/src/contexts/LegalProvisionContext';
import { useLocales } from '@raas/shared/src/locales';
import TextMaxLine from '../minimals/text-max-line';

export default function SelectedLegalProvision() {
  const { legalProvisionContext } = useContext(LegalProvisionContext);

  const { translate } = useLocales();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', flexGrow: 1 }}>
      <CardContent
        sx={{
          flex: '1 0 auto',
          padding: 0,
          pl: 1,
          width: 'fit-content',
          flexDirection: 'row',
          alignSelf: 'center',
          '&:last-child': { pb: 0 },
        }}
      >
        {legalProvisionContext && (
          <>
            <TextMaxLine line={2} sx={{ fontWeight: 'bold', maxWidth: '175px' }} variant="body2">
              {legalProvisionContext.fullName}
            </TextMaxLine>
            <TextMaxLine line={1} color="text.secondary" variant="caption">
              {`${translate('versions.versionName')}: ${legalProvisionContext.versionName}`}
            </TextMaxLine>
            {legalProvisionContext?.releaseTimestamp && (
              <TextMaxLine line={1} color="text.secondary" variant="caption">
                {`${translate(
                  'versions.releaseDate'
                )}: ${legalProvisionContext.releaseTimestamp.toDateString()}`}
              </TextMaxLine>
            )}
          </>
        )}
      </CardContent>
    </Box>
  );
}
